import history from '#/history';
import React from 'react';
import {
    Button, Container, Header, Icon
} from 'semantic-ui-react';

import logo from '../../logo.png';

const NoResults = props => {
    const { message = '404 No page found', redirectPath, children } = props;

    return (
        <Container style={styles.container} >
            <img
                style={{
                    margin: 'auto',
                    padding: '50px',
                    display: 'block'
                }}
                src={logo}
                alt='Smiley face'
                height='420'
                width='500'
            />
            <Header as='h1' textAlign='center'>{message}</Header>
            <Button
                primary
                style={styles.btnLink}
                onClick={() => history.push(redirectPath || '/')}
            >
                <Icon name='arrow alternate circle left'></Icon> Go Back
            </Button>
            {children}
        </Container>
    );
};

const styles = {
    btnLink: {
        width: '300px',
        height: '45px',
        margin: '0 auto'
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItem: 'center',
        flexDirection: 'column',
        width: '100%'
    }
};

export default NoResults;
